import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../util/classNames';
import { getGutterValue } from '../../util/styles/gutters';

export const useClassNames: () => GriffelClassNames<'root'> = makeStyles({
  root: {
    margin: `0 0 ${getGutterValue(4, true)}`,
    lineHeight: 'inherit',
  },
});
